// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/spatial-disorientation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/spatial-disorientation/spatial-disorientation.js';

mount([g0]);
